/* ============================================================
   WORKFLOW — "dropdown kaya" Control Panel tab Flow · PROTOTAIP (3 Nov 2026)
   ============================================================
   Lakaran 1 yang dipilih user 3 Nov: SATU dropdown. Tertutup = satu baris
   (gambar aliran + nama + ayat pendek). Dibuka = senarai dikumpul ikut jenis
   hasil (Image + video / Video only / Image only / Tools), setiap baris ada
   gambar aliran + nama + ayat pendek + tag. Tetapan di bawahnya ikut
   workflow yang dipilih.

   ⚠️ PROTOTAIP DESIGN SAHAJA — dipakai oleh /workspace-v3.9. Data = senarai
      permulaan WORKFLOW_MULA (utils/galeriWorkflow.js), bukan Firestore.
      Pilihan TIDAK masuk payload dan TIDAK menggerakkan robot. Versi SEBENAR
      (Workspace v4 mod New, data page /workflow) = WorkflowDropdownV4.jsx.
      Butang + menu dikongsi: PilihWorkflowKaya.jsx.
   ⛔ Draft: pelanggan TIDAK nampak langsung (keputusan 3 Nov — tiada kawalan
      palsu). Admin nampak dengan tanda Draft (`tunjukDraft`).
   ============================================================ */

import { useMemo, useState } from 'react';
import { useT } from '../i18n';
import PilihWorkflowKaya from './PilihWorkflowKaya';
import { WORKFLOW_MULA, susunWorkflow } from '../utils/galeriWorkflow';

const cx = (...parts) => parts.filter(Boolean).join(' ');

/* Tetapan tambahan setiap workflow (contoh prototaip). Tiada entri = tiada tetapan. */
const TETAPAN_WF = {
    'wf-sama': { scene: [1, 2, 3, 4, 5], hasil: true },
    'wf-berlainan': { scene: [2, 3, 4, 5], hasil: true },
    'wf-teks': { scene: [1, 2, 3, 4, 5], hasil: true },
    'wf-versi': { versi: [2, 3, 4] },
    'wf-gambar': { gambar: [1, 2, 3, 4] },
};

function Pil({ senarai, nilai, onPilih, label, papar = (x) => x, teks = false }) {
    return (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }} role="radiogroup" aria-label={label}>
            {senarai.map((x) => (
                <button
                    key={x} type="button" role="radio" aria-checked={nilai === x}
                    className={cx('s-pill', teks && 'wfp-pil--teks', nilai === x && 's-pill--on')}
                    onClick={() => onPilih(x)}
                >
                    {papar(x)}
                </button>
            ))}
        </div>
    );
}

export default function WorkflowPilihV39({ tunjukDraft = true }) {
    const t = useT();
    const senarai = useMemo(
        () => susunWorkflow(WORKFLOW_MULA.filter((w) => tunjukDraft || w.status === 'published')),
        [tunjukDraft],
    );
    const [nilai, setNilai] = useState(senarai[0]?.id || '');
    const [scene, setScene] = useState(3);
    const [hasil, setHasil] = useState('gabung');
    const [versi, setVersi] = useState(2);
    const [gambar, setGambar] = useState(1);

    const tetapan = TETAPAN_WF[nilai] || {};
    /* Bilangan scene dijepit ke julat workflow baharu bila bertukar (cth 1 → 2 untuk "berlainan"). */
    const sceneSah = tetapan.scene
        ? Math.min(Math.max(scene, tetapan.scene[0]), tetapan.scene[tetapan.scene.length - 1])
        : scene;

    return (
        <div className="s-sect">
            <p className="s-sect__title">{t('workspace.workflow.title')}</p>

            <PilihWorkflowKaya pilihan={senarai} nilai={nilai} onPilih={(w) => setNilai(w.id)} />

            {tetapan.scene && (
                <div>
                    <span className="s-lbl">{t('workspace.wfPilih.scenes')}</span>
                    <Pil senarai={tetapan.scene} nilai={sceneSah} onPilih={setScene} label={t('workspace.wfPilih.scenes')} />
                </div>
            )}
            {tetapan.hasil && sceneSah >= 2 && (
                <div>
                    <span className="s-lbl">{t('workspace.wfPilih.result')}</span>
                    <Pil
                        senarai={['gabung', 'asing', 'keduanya']}
                        nilai={hasil}
                        onPilih={setHasil}
                        label={t('workspace.wfPilih.result')}
                        papar={(x) => t(`workspace.wfPilih.result.${x}`)}
                        teks
                    />
                </div>
            )}
            {tetapan.versi && (
                <div>
                    <span className="s-lbl">{t('workspace.wfPilih.versions')}</span>
                    <Pil senarai={tetapan.versi} nilai={versi} onPilih={setVersi} label={t('workspace.wfPilih.versions')} papar={(x) => `x${x}`} />
                    <p className="s-hint">{t('workspace.wfPilih.versionsNote')}</p>
                </div>
            )}
            {tetapan.gambar && (
                <div>
                    <span className="s-lbl">{t('workspace.wfPilih.images')}</span>
                    <Pil senarai={tetapan.gambar} nilai={gambar} onPilih={setGambar} label={t('workspace.wfPilih.images')} />
                </div>
            )}

            {tunjukDraft && <p className="s-hint" style={{ margin: 0 }}>{t('workspace.wfPilih.draftNote')}</p>}
        </div>
    );
}
